module.exports = __webpack_public_path__ + "static/media/Graphik-Light.042a5b44.otf";